<!--
  ~ Developed for G.J. Gardner Homes by Softeq Development Corporation
  ~ http://www.softeq.com
  -->

<mat-icon svgIcon="gh:close" *ngIf="display &amp;&amp; !disabled" class="s16 gh-autocomplete-clear-icon" matTooltip="{{'lbl_clear' | translate}}"></mat-icon>
